import { Component, Inject, inject, PLATFORM_ID} from '@angular/core';
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-not-found',
  imports: [TranslateModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  private readonly translate= inject(TranslateService);
  private readonly router = inject(Router);
  messageKey = 'PageNotFound.texto';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("language") === null) {
        this.translate.setDefaultLang("es");
        localStorage.setItem("language", "es");
      } else {
        this.translate.setDefaultLang(localStorage.getItem("language") ?? '');
      }

      if (this.router.url.includes('/service-inactive')) {
        this.messageKey = 'PageNotFoundServiceCenterInactive.texto';
      }
    }
  }
}
